module.exports = __webpack_public_path__ + "img/生气.ffdd5dcf.gif";